import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTransmissionControlExpanded extends Layout {
    buttonAllRawData: Button;
    buttonOpenDescription: Button;
    horizontalspacer1: HorizontalSpacer;
    labelDescriptionLogging: Label;
    labelDetailLogging: Label;
    labelFuncTotal: Label;
    labelFunctionalRawData: Label;
    labelTransTotal: Label;
    labelTransmissionSet: Label;
    panelControlExpanded: Panel;
    panelDetailLogging: Panel;
    panelFuncRawData: Panel;
    panelFunctionalRawData: Panel;
    panelRawData: Panel;
    panelText: Panel;
    panelTransSetRawData: Panel;
    sourceEdiFunctionalGrp: DataSource;
    sourceEdiTransSet: DataSource;
    sourceTransmissionControlList: DataSource;
    tableFunctionalGroup: Table;
    tableTransmissionSet: Table;
}
